import React, { useEffect, useState } from "react";

import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import clsx from "clsx";
import mainStyles from "styles";

import { EnumSelectProps } from "types/org-display";

const EnumDropdown: React.FC<EnumSelectProps> = ({
  enum: enumProp,
  label,
  defaultValue,
  onValueChange,
  displayMapping,
}) => {
  const classes = mainStyles();
  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    setSelectedValue(defaultValue || "");
  }, [defaultValue]);

  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    const value = event.target.value as string;
    setSelectedValue(value);
    if (onValueChange) {
      onValueChange(value);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <FormControl
        variant="outlined"
        size="small"
        className={clsx(classes.spaceTopSmall, classes.spaceRightMedium)}
        fullWidth
      >
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedValue}
          onChange={handleChange}
          label={label}
          data-testid="enum-dropdown"
        >
          {Object.entries(enumProp)
            .filter(([, value]) => typeof value !== "string" && value !== 0)
            .map(([key, value]) => (
              <MenuItem key={key} value={value}>
                {displayMapping ? displayMapping[value] || key : key}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EnumDropdown;
